import React from "react";

import { VictoryChart, VictoryAxis, VictoryZoomContainer } from "victory";

function BaseLineChart(props) {
  const {
    data,
    minYDomain,
    maxYDomain,
    yAxisValues,
    yAxisLabel,
    figureCaption,
    visibilityController,
  } = props;
  return (
    <div
      className="flex flex-col items-center justify-center w-full h-[38rem] 
                 rounded-xl border-2 border-neutral-300
                 cursor-pointer overflow-hidden"
    >
      <VictoryChart
        domainPadding={{ x: [50, 50], y: 50 }}
        minDomain={{ y: minYDomain }}
        maxDomain={{ y: maxYDomain }}
        height={500}
        width={window.innerWidth}
        padding={{ top: 20, left: 100, right: 100, bottom: 100 }}
        containerComponent={
          // Use VictoryZoomContainer for zoom functionality
          <VictoryZoomContainer
            minimumZoom={{ x: 2 }}
            // Allow zoom only on the x-axis
            zoomDimension="x"
          />
        }
      >
        {/* DATA START */}
        {props.children}
        {/* DATA END */}

        {/* X-axis */}
        <VictoryAxis
          // tickValues={data.map((d) => d.created)}
          categories={{
            x: data.map((d) => String(d.created)),
          }}
          // Custom tick format to display time in minutes
          tickFormat={(x) => {
            const date = new Date(x);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");

            let hours = date.getHours();
            let minutes = String(date.getMinutes()).padStart(2, "0");

            const ampm = hours >= 12 ? "PM" : "AM";

            hours = hours % 12;
            hours = hours ? String(hours).padStart(2, "0") : "12"; // the hour '0' should be '12'

            return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
          }}
          style={{
            tickLabels: {
              fontSize: 15,
              angle: 15,
              textAnchor: "start",
            },
            // Style for the X axis label
            axisLabel: {
              fontSize: 30,
              padding: 70,
            },
            grid: { stroke: "#ccc" },
            axis: { stroke: "#756f6a", strokeWidth: 3 },
          }}
          label={"Time of Entry"}
        />
        {/* Y-axis */}
        <VictoryAxis
          tickValues={yAxisValues}
          dependentAxis
          tickFormat={(y) => `${y}`}
          style={{
            // Style for the Y axis label
            axisLabel: {
              fontSize: 30,
              padding: 35,
            },
            grid: { stroke: "#ccc" },
            axis: { stroke: "#756f6a", strokeWidth: 3 },
          }}
          label={yAxisLabel}
        />
      </VictoryChart>

      {visibilityController}

      <div className="flex flex-row items-center justify-start w-full pl-8 pb-4">
        <p className="text-xl font-medium text-neutral-800">{figureCaption}</p>
      </div>
    </div>
  );
}

export default BaseLineChart;
